// extracted by mini-css-extract-plugin
export var actions = "_un-4";
export var item = "_un-1";
export var price = "_un-3";
export var quantity = "_un-2";
export var table = "_un-0";